import { defineStyle, defineStyleConfig } from "@chakra-ui/react";

const brand = defineStyle({
  color: "dark.500",
});

export const Link = defineStyleConfig({
  baseStyle: {
    color: "brand.500",
  },
  variants: { brand },
  defaultProps: { variant: "brand" },
});
